import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectiveModule } from '@/directives/directive.modules';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ErrorsLabelModule } from '../errors-label/errors-label.module';
import { InputTextComponent } from './input-text.component';
import { InputComponent } from '@/shared/components/input.component';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
  declarations: [InputTextComponent, InputComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ErrorsLabelModule,
    FormsModule,
    ReactiveFormsModule,
    DirectiveModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [InputTextComponent, InputComponent],
  providers: [provideNgxMask()],
})
export class InputTextModule {}
